// import moment from 'moment'

export const mutations = {
  setUser (state, user) {
    state.user = user

    if (user) {
      sessionStorage.setItem('user', JSON.stringify(state.user))
    } else {
      sessionStorage.removeItem('user')
    }
  },
  setError (state, payload) {
    state.error = payload
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setLoadingDescript (state, payload) {
    state.loadingDescript = payload
  },
  setIsAutoRecognize (state, payload) {
    state.isAutoRecognize = payload
  },
  // KAN-95 暗室暗色主題切換
  SET_UI_THEME (state, theme) {
    state.ui = { ...state.ui, theme }
  },
  SET_SETTING(state, setting) {
    state.setting = setting
  },
  // 醫院別 runtime 配置（由 /api/config/runtime 載入）
  SET_HOSPITAL(state, hospital) {
    state.hospital = hospital
  },
  SET_LICENSE(state, runtime) {
    state.license = { ...runtime, loaded: true }
  },
  SET_LICENSE_RESTRICTION_NOTICE(state, notice) {
    state.licenseRestrictionNotice = notice
  },
  SET_CLINICAL_STATE_LOCK(state, locked) {
    state.clinicalStateLocked = Boolean(locked)
    if (locked) state.clinicalRequestEpoch += 1
  },
}
